import { FormHelperText, InputLabel, OutlinedInput } from '@mui/material';
import { Field, ErrorMessage } from 'formik';
import React from 'react';
import { styled } from '@mui/material/styles';

const StyledInput = styled(OutlinedInput)(({ theme }) => ({
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `black !important`,
  },
  'input': {
    padding: "10px 16px 10px 16px",
  }
}));

const InputField = ({ label, required, fieldType, ...props }) => {

  return (
    <>
      {label && (
        <InputLabel htmlFor={props.id || props.name}>
          {label}
          {required && '*'}
        </InputLabel>
      )}
      <Field as={fieldType ? StyledInput : OutlinedInput} {...props} />
      <ErrorMessage name={props.name}>
        {(error) => (
          <FormHelperText error id={`${props.name}-error`}>
            {error}
          </FormHelperText>
        )}
      </ErrorMessage>
    </>
  );
};

export default InputField;
